import angular from 'angular';
import StockSoftware from '../data/stock-software.data';
import Cooperative from '../data/cooperative.data';
import FileSaver from 'file-saver';

(function () {
    'use strict';
    angular.module('app.core').factory('CommunityDA', CommunityDA);

    CommunityDA.$inject = ['Restangular', 'CONF', 'Upload', 'Community', 'Document', '$http', 'Brand', '$translate'];

    /**
     * Class permettant la manipulation des infos relatives aux communautés.
     */

    /* @ngInject */
    function CommunityDA(Restangular, CONF, Upload, Community, Document, $http, Brand, $translate) {
        var baseUrl = CONF.apiBaseUrl + '/v1/communities';
        var baseDocumentUrl = CONF.apiBaseUrl + '/v1/documents';
        var baseUrlStockSoftware = CONF.apiBaseUrl + '/v1/stock-software';
        var baseUrlCooperative = CONF.apiBaseUrl + '/v1/cooperatives';

        var exports = {
            saveCommunity: saveCommunity,
            importMembers: importMembers,
            getAllCommunities: getAllCommunities,
            getCommunityById: getCommunityById,
            updateCommunity: updateCommunity,
            getAllCompaniesOfCommunity: getAllCompaniesOfCommunity,
            getAllCooperativesOfCommunity: getAllCooperativesOfCommunity,
            deleteComunity: deleteComunity,
            getAllStockSoftware: getAllStockSoftware,
            updateCommunityPortal: updateCommunityPortal,
            getStockSoftware: getStockSoftware,
            updateStockSoftware: updateStockSoftware,
            createStockSoftware: createStockSoftware,
            checkStockSoftwareName: checkStockSoftwareName,
            getBrand: getBrand,
            uploadCgaZip: uploadCgaZip,
            getCgaInfos: getCgaInfos,
            getCgaZip: getCgaZip,
            saveCooperative: saveCooperative,
            updateCooperative: updateCooperative,
            getCooperative: getCooperative,
            getAllReferentialsOfCommunity: getAllReferentialsOfCommunity,
            saveAllReferentials: saveAllReferentials,
            isCooperativeDeletable: isCooperativeDeletable,
            deleteCooperative: deleteCooperative,
            disableProductCatalogManagementForAllSubEntities: disableProductCatalogManagementForAllSubEntities,
            getAllSimpleCommunities: getAllSimpleCommunities,
        };

        return exports;

        /**
         * Sauvegarde d'une communauté.
         * @param {json}  community - les données de la communauté à créer.
         */
        function saveCommunity(community) {
            return Restangular.all(baseUrl).post(community);
        }

        /**
         * Modification d'une communauté
         */
        function updateCommunity(community) {
            return Restangular.one(baseUrl, community.eid).customPUT(community);
        }

        function importMembers(criteria) {
            return Upload.upload({
                url: CONF.apiContext + baseUrl + '/membership/import',
                data: {
                    file: criteria.file,
                },
            });
        }

        function uploadCgaZip(document, eid) {
            return Upload.upload({
                url: CONF.apiContext + baseDocumentUrl + '/upload/cga',
                data: {
                    file: document.file,
                    version: document.version,
                    community: eid,
                },
            }).then(
                function (data) {
                    return data;
                },
                function (error) {
                    return error;
                }
            );
        }

        function getCgaInfos(eid) {
            return Restangular.one(baseDocumentUrl + '/' + eid)
                .get()
                .then(function (data) {
                    const docs = [];
                    if (data.id != null) {
                        docs.push(new Document(data));
                    }
                    return docs;
                });
        }

        function getCgaZip(documentId) {
            return $http({
                method: 'POST',
                url: CONF.apiContext + baseDocumentUrl + '/cga/' + documentId,
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer',
            }).then(function (response) {
                var blob = new Blob([response.data], {
                    type: 'application/binary',
                });
                FileSaver.saveAs(blob, 'cga.zip');
                return response;
            });
        }


        function getAllCommunities(page, size) {
            return Restangular.all(baseUrl)
                .one('list')
                .customGET('', {
                    page: page,
                    size: size
                }
                )
                .then(data => {
                    return data;
                });
        }

        function getCommunityById(eid) {
            return Restangular.one(baseUrl + '/' + eid)
                .get()
                .then(function (data) {
                    return data;
                });
        }

        function getAllCompaniesOfCommunity(communityEid, pageNumber, size) {
            pageNumber = pageNumber > 0 ? pageNumber - 1 : 0;
            return $http({
                method: 'POST',
                url: CONF.apiContext + baseUrl + '/' + communityEid + '/companies?page=' + pageNumber + '&size=' + size,
            });
        }

        function getAllCooperativesOfCommunity(communityEid, pageNumber, size) {
            pageNumber = pageNumber > 0 ? pageNumber - 1 : 0;
            return $http({
                method: 'POST',
                url:
                    CONF.apiContext +
                    baseUrl +
                    '/' +
                    communityEid +
                    '/cooperatives?page=' +
                    pageNumber +
                    '&size=' +
                    size,
            });
        }

        /**
         * Supprime d'une community.
         * @param communityEid Identifiant d'une community
         */
        function deleteComunity(communityEid) {
            return Restangular.one(baseUrl, communityEid).remove();
        }

        /**
         * Recherche tous les logiciels de stock agrée DiagDirect
         *
         */
        function getAllStockSoftware() {
            return Restangular.all(baseUrlStockSoftware)
                .one('list')
                .get()
                .then(function (data) {
                    return data;
                });
        }

        /**
         * Modifie la configuration du portail de la communauté.
         */
        function updateCommunityPortal(community) {
            return Restangular.one(baseUrl).one('portal').customPUT(community);
        }

        /**
         * Récupère un logiciel de stock agrée DiagDirect par nom de logiciel.
         */
        function getStockSoftware(id) {
            return Restangular.all(baseUrlStockSoftware)
                .one(id)
                .get()
                .then(function (data) {
                    return new StockSoftware(data, $translate);
                });
        }

        /**
         * Modifie un logiciel de stock agrée DiagDirect.
         */
        function updateStockSoftware(stockSoftware) {
            return Restangular.all(baseUrlStockSoftware).customPUT(stockSoftware);
        }

        /**
         * Crée un logiciel de stock agrée DiagDirect.
         */
        function createStockSoftware(stockSoftware) {
            return Restangular.all(baseUrlStockSoftware).customPOST(stockSoftware);
        }

        /**
         * Vérifie que le nom d'un logiciel de stock agréé DiagDirect n'est pas utilisé.
         */
        function checkStockSoftwareName(name) {
            return Restangular.all(baseUrlStockSoftware).one('exist').customGET(name);
        }

        /**
         * Récupère la personnalisation de la communauté.
         */
        function getBrand(communityId) {
            return Restangular.one(baseUrl, communityId)
                .one('brand')
                .get()
                .then(function (data) {
                    return new Brand(data);
                });
        }

        /**
         * Sauvegarde d'un groupement.
         * @param {json}  Cooperative - les données du groupement à créer.
         */
        function saveCooperative(cooperative) {
            return Restangular.all(baseUrlCooperative + '/create').post(cooperative);
        }
        /**
         * Update d'un groupement.
         * @param {json}  Cooperative - les données du groupement à MAJ.
         */
        function updateCooperative(cooperative) {
            return Restangular.all(baseUrlCooperative + '/update').post(cooperative);
        }
        /**
         * Récupère un groupement
         * @param id Identifiant groupement
         */
        function getCooperative(id) {
            return Restangular.all(baseUrlCooperative)
                .one(id)
                .get()
                .then(function (data) {
                    return new Cooperative(data, $translate);
                });
        }
        /**
         * Récupère la liste des référentiels data repo d'une communauté
         * @param querySearchCriteria critères de recherche
         */
        function getAllReferentialsOfCommunity(querySearchCriteria) {
            return $http({
                method: 'POST',
                url:
                    CONF.apiContext +
                    baseUrl +
                    '/' +
                    querySearchCriteria.clientCode +
                    '/referentials',
                data: querySearchCriteria
            });
        }
        /**
         * Enregistrer la liste des référentiels data repo d'une communauté
         * @param referentials critères de recherche
         */
        function saveAllReferentials(querySearchCriteria, referentials) {
            return $http({
                method: 'POST',
                url:
                    CONF.apiContext +
                    baseUrl +
                    '/' +
                    querySearchCriteria.clientCode +
                    '/referentials/saveAll?model='+querySearchCriteria.model+'&control='+querySearchCriteria.control,
                data: referentials
            });
        }
        /**
         * Retourne True si le groupement est supprimable.
         */
        function isCooperativeDeletable(cooperativeId) {
            return Restangular.one(baseUrlCooperative + '/' + cooperativeId + '/' + 'deletable')
                .get();
        }
        /**
        * Supprime un groupement.
        * @param id Identifiant d'un groupement
        */
        function deleteCooperative(id) {
            return Restangular.one(baseUrlCooperative + '/' + id).remove();
        }

        /**
         * Désactive l'option autoriser les clients à consulter le catalogue pour les établissments et les division adhérant
         * à une communauté qui ne gère pas un catalogue de produits
         *
         * @param communityId
         */
        function disableProductCatalogManagementForAllSubEntities(communityId) {
            return Restangular.one(baseUrl + '/' + communityId + '/' + '/sub-entity/disable-catalog')
                .get();
        }

        function getAllSimpleCommunities() {
            return Restangular.one(baseUrl + '/all')
                .get()
                .then(function (data) {
                    return data;
                });
        }
    }
})();
